const DEEPLINK_BASE_URL = 'https://app.puzzle.online';

type RoutingPresentation =
  | 'rootNavigationFlow'
  | 'partialSheet'
  | 'fullScreenCover';

export const getDeeplinkBrowserUrl = (
  url: string,
  routingPresentation?: RoutingPresentation
) => {
  const deeplinkUrl = new URL('/browser', DEEPLINK_BASE_URL);
  const searchParams = new URLSearchParams();

  searchParams.set('url', url);
  if (routingPresentation) {
    searchParams.set('routingPresentation', routingPresentation);
  }

  deeplinkUrl.search = searchParams.toString();
  return deeplinkUrl.toString();
};
